import am4geodata_worldIndiaLow from "@amcharts/amcharts4-geodata/worldIndiaLow";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useEffect, useState } from "react";

const WorldMapChart = ({ finalMapData, countryType, hsCode, countryName, isMultiCountry }) => {
  const [chartData, setChartData] = useState("");

  useEffect(() => {
    let data = [];
    if (finalMapData && Array.isArray(finalMapData)) {
      for (let i = 0; i < finalMapData.length; i++) {
        if (finalMapData[i].data && finalMapData[i].data.id && finalMapData[i].data.shipment_count) {
          let obj = {};
          obj.id = finalMapData[i].data.id;
          obj.value = parseInt(finalMapData[i].data.shipment_count);
          obj.hsCode = hsCode;
          obj.tooltipText = isMultiCountry ? "" : finalMapData[i].data.country_name && countryName && countryName.toLowerCase() === finalMapData[i].data.country_name.toLowerCase() && countryType && countryType.includes("imp") ? "imports from other countries" : finalMapData[i].data.country_name && countryName && countryName.toLowerCase() === finalMapData[i].data.country_name.toLowerCase() && countryType && countryType.includes("exp") ? "exports to other countries" : countryType && countryType.includes("imp") ? `to ${countryName}` : `from ${countryName}`;
          data.push({ ...obj });
        }
      }
    }
    setChartData([...data]);
  }, [finalMapData]);

  useEffect(() => {
    // Create chart instance
    const chart = am4core.create("chartdiv", am4maps.MapChart);
    chart.projection = new am4maps.projections.Miller();
    chart.zoomControl = new am4maps.ZoomControl();
    chart.zoomControl.align = "right";
    chart.zoomControl.marginRight = 15;
    chart.seriesContainer.draggable = true;
    chart.seriesContainer.resizable = false;
    chart.mouseWheelBehavior = "none"; // Disable mouse wheel zoom

    let homeButton = new am4core.Button();
    homeButton.events.on("hit", function () {
      chart.goHome();
    });

    homeButton.icon = new am4core.Sprite();
    homeButton.padding(7, 5, 7, 5);
    homeButton.width = 30;
    homeButton.icon.path = "M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8";
    homeButton.marginBottom = 10;
    homeButton.parent = chart.zoomControl;
    homeButton.insertBefore(chart.zoomControl.plusButton);

    // Center on the groups by default
    chart.homeZoomLevel = 0;
    chart.homeGeoPoint = { longitude: 5, latitude: 20 };

    chart.geodata = am4geodata_worldIndiaLow;

    // Create map polygon series
    const polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
    polygonSeries.useGeodata = true;
    polygonSeries.exclude = ["AQ"];

    let mapPolygonTemplate = polygonSeries.mapPolygons.template;
    mapPolygonTemplate.events.on("over", function (event) {
      polygonSeries.mapPolygons.each(function (mapPolygon) {
        mapPolygon.isHover = true;
      });
      event.target.isHover = false;
      event.target.isHover = true;
    });

    // Set tooltip
    const polygonTemplate = polygonSeries.mapPolygons.template;

    polygonTemplate.adapter.add("tooltipHTML", (text, target) => {
      let data = target.tooltipDataItem.dataContext;
      if (target.tooltipDataItem.dataContext && !!data.value && data.value > 0) {
        return '<span className="d-flex align-items-center" style="font-size: 14px;">Trade Details of {name} {tooltipText} for HS Code {hsCode} <br/>Total Shipments: {value}</span>';
      } else {
        return text;
      }
    });

    polygonSeries.tooltip.getFillFromObject = false;
    polygonSeries.tooltip.label.fill = "#ffffff";
    polygonSeries.tooltip.background.fill = "#101828";
    polygonSeries.tooltip.background.stroke = "#101828";

    // Set fill color based on data values
    polygonSeries.heatRules.push({
      property: "fill",
      target: polygonSeries.mapPolygons.template,
      min: am4core.color("#AA8EF7"),
      max: am4core.color("#5A1CE2"),
    });

    // Set data source
    polygonSeries.data = chartData;

    //remove amchart logo
    if (chart.logo) {
      chart.logo.disabled = true;
    }

    //changing mouse cursor
    mapPolygonTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer;

    // Apply theme
    am4core.useTheme(am4themes_animated);

    // Return cleanup function
    return () => {
      chart.dispose();
    };
  }, [chartData]);

  return <div id="chartdiv"></div>;
};

export default WorldMapChart;
